/* eslint-disable indent */
import { Component, Vue } from 'vue-property-decorator';

import styles from './app.component.scss';
import WithRender from './app.component.html';
import { moduleProxy } from '@/store';
import HeaderComponent from '@/components/Shared/header.component.vue';
import AlertComponent from '@/components/alert.component.vue';
import { AlertOptions } from '@/store/main-alert.store';
import DialogComponent from '@/components/dialog/dialog.component.vue';
// Helpers
import { getThemeColor } from './appTheme';

@WithRender
@Component({
  components: {
    HeaderComponent,
    AlertComponent,
    DialogComponent,
  },
})
export default class App extends Vue {
  public styles = styles;

  get headerData() {
    const header = moduleProxy.Header.getHeaderData;
    return header;
  }

  get alertOptions(): AlertOptions {
    return moduleProxy.mainAlert.alertOptions;
    }
    mounted() {
        this.updateUIFrameWork();
    }

    public updateUIFrameWork() {
        const { primary, secondary } = this.$vuetify.theme.themes.light;
        const lightTheme = this.$vuetify.theme.themes.light;

        lightTheme.primary = getThemeColor('primary') || primary;
        lightTheme.secondary = getThemeColor('secondary') || secondary;
    }
}
